import classnames from 'classnames';
import LocalizedLink from 'components/LocalizedLink';
import { LocationDescriptor } from 'history';
import React from 'react';
import { useTrekker } from 'utils/analytics';

const CSS = require('./RoundedButton.module.scss');

interface LocalizedLinkButtonProps {
  children: any;
  size?: 'XS' | 'S' | 'M' | 'L';
  className?: string;
  inverted?: boolean;
  pink?: boolean;
  yellow?: boolean;
  sandstone?: boolean;
  jade?: boolean;
  danger?: boolean;
  onClick?: (event: any) => void;
  fullWidth?: boolean;
  invertedBorder?: boolean;
  outlined?: boolean;
  elevated?: boolean;
  to: LocationDescriptor;
  edgeRounding?: 'slight' | 'medium' | 'full';
  [key: string]: any;
}

function LocalizedLinkButton({
  size = 'M',
  children,
  className,
  inverted,
  pink,
  yellow,
  sandstone,
  jade,
  danger,
  fullWidth,
  invertedBorder,
  outlined,
  elevated,
  onClick,
  to,
  edgeRounding = 'full',
  ...rest
}: LocalizedLinkButtonProps) {
  const trekker = useTrekker();
  const classes = classnames(CSS.Button, CSS.Link, {
    [className]: className,
    [CSS.Inverted]: inverted,
    [CSS.InvertedBorder]: invertedBorder,
    [CSS.PinkButton]: pink,
    [CSS.YellowButton]: yellow,
    [CSS.SandstoneButton]: sandstone,
    [CSS.JadeButton]: jade,
    [CSS.DangerButton]: danger,
    [CSS.FullWidth]: fullWidth,
    [CSS.ExtraSmall]: size === 'XS',
    [CSS.Large]: size === 'L',
    [CSS.Small]: size === 'S',
    [CSS.EdgeRoundedSlight]: edgeRounding === 'slight',
    [CSS.EdgeRoundedMedium]: edgeRounding === 'medium',
    [CSS.OutlinedButton]: outlined,
    [CSS.ButtonElevated]: elevated,
  });
  const handleClick = (event: any) => {
    trekker?.event('click', { linkTo: to });
    onClick?.(event);
  };

  return (
    <LocalizedLink to={to} className={classes} onClick={handleClick} {...rest}>
      <span className={CSS.LinkChildren}>{children}</span>
    </LocalizedLink>
  );
}

export default LocalizedLinkButton;
